// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { McsGdsBaseProjectHelper } from '@project/helper/mcs-gds-base-project.helper';
import { UserVO } from '@user/model/vo/user.vo';
import { ProjectType } from '../model/project-type';
import { IResponsibleForProjectTypeHelper } from './i-project.helper';

@Injectable({providedIn: 'root'})
export class McsProjectHelper extends McsGdsBaseProjectHelper implements IResponsibleForProjectTypeHelper {
  public isReplaceWithDifferentWidthAllowed(): boolean {
    return this.projectModel.user && this.projectModel.user.hasPermission("REPLACE_ARTICLE_WITH_DIFFERENT_WIDTH_IN_MCS_PROJECT");
  }

  public isDisplayOfProjectStructureEnabled(user: UserVO = null): boolean {
    const enabledFromProjectModel = this.isViewProjectStructureAllowedBecauseOfMCSGDSBaseArticle(this.projectModel.currentProject);
    const enabledFromUser = this.checkUserPermission(user, "VIEW_PROJECT_STRUCTURE_IN_MCS_PROJECT");
    return enabledFromProjectModel || enabledFromUser;
  }

  public isCopyPasteAllowed(): boolean {
    return false;
  }

  public userHasPermissionToDeleteMainPartComplexArticle(): boolean {
    return this.projectModel.user.hasPermission("DELETE_MAIN_PART_OF_COMPLEX_ARTICLE_IN_MCS_PROJECT");
  }

  public isResponsible(projectType: ProjectType): boolean {
    return projectType === "MCS";
  }
}
